import { useId } from 'react';
import { SVGProps } from '../types';

const PneumaIcon = (props: SVGProps) => {
  const maskId = useId();
  const star =
    'M13.4406 2.15939C12.6204 3.52646 12.6204 4.89354 13.4406 6.26061C12.0735 5.44037 10.7065 5.44037 9.33939 6.26061C10.1596 4.89354 10.1596 3.52646 9.33939 2.15939C10.7065 2.97963 12.0735 2.97963 13.4406 2.15939Z';

  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask
        id={`${maskId}-rim`}
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="16"
      >
        <rect width="16" height="16" fill="white" />
        <path
          d={star}
          fill="black"
          stroke="black"
          strokeWidth="1.9"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </mask>
      <g mask={`url(#${maskId}-rim)`}>
        <path
          d="M3.92501 9.87227C4.99399 10.3064 6.18357 10.3409 7.27594 9.9696C8.36831 9.59827 9.29039 8.84589 9.87333 7.85022C10.4563 6.85456 10.6611 5.68224 10.4503 4.5479C10.2394 3.41356 9.62707 2.39312 8.72531 1.6734C7.82355 0.953681 6.69272 0.582854 5.53987 0.628813C4.38702 0.674771 3.2893 1.13444 2.44769 1.92366C1.60608 2.71287 1.0769 3.77883 0.957043 4.92635C0.837182 6.07387 1.13466 7.22617 1.79501 8.17227L0.625015 11.0223L3.92501 9.87227Z"
          transform="translate(2.275 2.175)"
          stroke="currentColor"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <path d={star} fill="currentColor" />
      <path
        d="M1.5 0C1.7 0.8 2.2 1.3 3 1.5C2.2 1.7 1.7 2.2 1.5 3C1.3 2.2 0.8 1.7 0 1.5C0.8 1.3 1.3 0.8 1.5 0Z"
        transform="rotate(45 9.87 7.87) translate(8.37 6.37)"
        fill="currentColor"
      />
    </svg>
  );
};

export { PneumaIcon };
